<template>
  <div id="ListVamRequests" @click.capture="onButtonClick">
    <loading v-if="loadingRender"></loading>
    <panel
      Title="گزارش درخواست های تسهیلات"
      Des="از طریق این فرم می توانید لیست درخواست های تسهیلات را مشاهده و مدیریت نمایید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <net-pa-card>
            <template slot="header">
              <h6 class="text-right">
                <i class=""></i>لیست درخواست های تسهیلات
              </h6>
            </template>
            <template slot="content">
              <div class="list-vam-requests-filters">
                <div class="list-vam-requests-field">
                  <label class="list-vam-requests-label"
                    >انتخاب وضعیت درخواست</label
                  >
                  <select class="form-control" v-model="FilterGrp312">
                    <option :value="-1">همه حالت ها</option>
                    <option
                      v-for="(item, key) in Grp312"
                      :key="key"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class="list-vam-requests-field list-vam-requests-action">
                  <span
                    class="list-vam-requests-label list-vam-requests-label--spacer"
                    aria-hidden="true"
                    >&nbsp;</span
                  >
                  <button
                    type="button"
                    class="btn btn-success list-vam-requests-search-btn"
                    @click="Serach"
                  >
                    <i class="fa fa-search ml-1" aria-hidden="true"></i>
                    جستجو
                  </button>
                </div>
              </div>

              <div class="list-vam-requests-results">
                <div class="list-vam-requests-cards" dir="rtl">
                  <p v-if="!rows.length" class="list-vam-requests-cards__empty">
                    موردی برای نمایش وجود ندارد
                  </p>
                  <template v-else>
                    <div class="list-vam-requests-cards__toolbar">
                      <input
                        v-model="cardSearch"
                        type="search"
                        class="form-control list-vam-requests-cards__search"
                        placeholder=" جستجو"
                        aria-label="جستجو در درخواست‌ها"
                      />
                      <button
                        type="button"
                        class="list-vam-requests-export-btn"
                        title="Excel"
                        aria-label="دانلود Excel"
                        @click="Download"
                      >
                        <i class="fas fa-file-excel" aria-hidden="true"></i>
                      </button>
                    </div>
                    <p
                      v-if="filteredCardRows.length === 0"
                      class="list-vam-requests-cards__empty"
                    >
                      اطلاعاتی یافت نشد
                    </p>
                    <div v-else class="list-vam-requests-cards__list">
                      <article
                        v-for="(row, index) in pagedCardRows"
                        :key="(row.id || 'row') + '-' + index"
                        class="list-vam-requests-card"
                      >
                        <div class="list-vam-requests-card__header">
                          <strong class="list-vam-requests-card__name">{{
                            row.fullName
                          }}</strong>
                          <span
                            v-if="row.stateVam"
                            class="list-vam-requests-card__badge"
                            >{{ row.stateVam }}</span
                          >
                        </div>
                        <div
                          v-if="row.mablagh != null && row.mablagh !== ''"
                          class="list-vam-requests-card__amount"
                        >
                          <span dir="ltr">{{
                            $Comma3ragham(row.mablagh)
                          }}</span>
                          <small>{{ $GetVahedPool() }}</small>
                        </div>
                        <div class="list-vam-requests-card__fields">
                          <div
                            v-if="row.desNoe"
                            class="list-vam-requests-card__field"
                          >
                            <span>نوع تسهیلات</span>
                            <strong>{{ row.desNoe }}</strong>
                          </div>
                          <div
                            v-if="row.requestTarix"
                            class="list-vam-requests-card__field"
                          >
                            <span>تاریخ درخواست</span>
                            <strong>{{ row.requestTarix }}</strong>
                          </div>
                          <div
                            v-if="row.codeMeli"
                            class="list-vam-requests-card__field"
                          >
                            <span>کد ملی</span>
                            <strong dir="ltr">{{ row.codeMeli }}</strong>
                          </div>
                          <div
                            v-if="row.codeRahgiri"
                            class="list-vam-requests-card__field"
                          >
                            <span>کد رهگیری</span>
                            <strong dir="ltr">{{ row.codeRahgiri }}</strong>
                          </div>
                          <div
                            v-if="row.perNo"
                            class="list-vam-requests-card__field"
                          >
                            <span>شماره پرسنلی</span>
                            <strong dir="ltr">{{ row.perNo }}</strong>
                          </div>
                          <div
                            v-if="row.tedadGhest"
                            class="list-vam-requests-card__field"
                          >
                            <span>تعداد اقساط</span>
                            <strong dir="ltr">{{ row.tedadGhest }}</strong>
                          </div>
                          <div
                            v-if="row.ramzKasrAghsat"
                            class="list-vam-requests-card__field"
                          >
                            <span>کسر اقساط</span>
                            <strong>{{ row.ramzKasrAghsat }}</strong>
                          </div>
                          <div
                            v-if="row.hesabNo"
                            class="list-vam-requests-card__field"
                          >
                            <span>شماره حساب</span>
                            <strong dir="ltr">{{ row.hesabNo }}</strong>
                          </div>
                          <div
                            v-if="row.sepordeTime"
                            class="list-vam-requests-card__field"
                          >
                            <span>مدت سپرده</span>
                            <strong>{{ row.sepordeTime }}</strong>
                          </div>
                        </div>
                        <div class="list-vam-requests-card__actions">
                          <button
                            class="list-vam-requests-row-btn list-vam-requests-row-btn--guarantor"
                            type="button"
                            title="ضامن‌ها"
                            @click="DetailVam(row)"
                            data-toggle="modal"
                            data-target="#Modal-light"
                          >
                            <i
                              class="fas fa-user-friends"
                              aria-hidden="true"
                            ></i>
                            <span>ضامن‌ها</span>
                          </button>
                          <button
                            class="list-vam-requests-row-btn list-vam-requests-row-btn--download"
                            type="button"
                            title="دانلود فایل‌ها"
                            @click="DownloadAttachment(row.id, null)"
                          >
                            <i class="fas fa-download" aria-hidden="true"></i>
                            <span>دانلود فایل‌ها</span>
                          </button>
                          <button
                            class="list-vam-requests-row-btn list-vam-requests-row-btn--status"
                            type="button"
                            title="تغییر وضعیت"
                            @click="Changestate(row)"
                            data-toggle="modal"
                            data-target="#Modal-light"
                          >
                            <i
                              class="fas fa-exchange-alt"
                              aria-hidden="true"
                            ></i>
                            <span>تغییر وضعیت</span>
                          </button>
                        </div>
                      </article>
                    </div>
                    <div
                      v-if="filteredCardRows.length > cardPerPage"
                      class="list-vam-requests-cards__pager"
                    >
                      <button
                        type="button"
                        class="list-vam-requests-cards__pager-btn"
                        :disabled="cardPage <= 1"
                        @click="cardPage = cardPage - 1"
                      >
                        قبلی
                      </button>
                      <span class="list-vam-requests-cards__pager-info">
                        صفحه {{ cardPage }} از {{ cardPageCount }}
                      </span>
                      <button
                        type="button"
                        class="list-vam-requests-cards__pager-btn"
                        :disabled="cardPage >= cardPageCount"
                        @click="cardPage = cardPage + 1"
                      >
                        بعدی
                      </button>
                    </div>
                  </template>
                </div>
                <div class="list-vam-requests-table-view">
                  <vue-bootstrap4-table
                    :rows="rows"
                    :columns="columns"
                    :config="config"
                    :classes="classes"
                    :actions="actions"
                    @on-download="Download"
                    @on-download-pdf="GetPDF"
                  >
                    <template slot="global-search-clear-icon">
                      <i class="fas fa-times-circle"></i>
                    </template>
                    <template slot="sort-asc-icon">
                      <i class="fa fa-sort-up"></i>
                    </template>
                    <template slot="sort-desc-icon">
                      <i class="fa fa-sort-down"></i>
                    </template>
                    <template slot="no-sort-icon">
                      <i class="fa fa-sort"></i>
                    </template>
                    <template slot="empty-results">
                      <p class="text-right">اطلاعاتی یافت نشد</p>
                    </template>
                    <template slot="mablagh" slot-scope="props">
                      <p class="text-center">
                        {{ $Comma3ragham(props.row.mablagh) }}
                      </p>
                    </template>
                    <template slot="Action" slot-scope="props">
                      <div class="list-vam-requests-row-actions">
                        <button
                          class="list-vam-requests-row-btn list-vam-requests-row-btn--guarantor"
                          type="button"
                          title="ضامن‌ها"
                          @click="DetailVam(props.row)"
                          data-toggle="modal"
                          data-target="#Modal-light"
                        >
                          <i class="fas fa-user-friends" aria-hidden="true"></i>
                          <span>ضامن‌ها</span>
                        </button>
                        <button
                          class="list-vam-requests-row-btn list-vam-requests-row-btn--download"
                          type="button"
                          title="دانلود فایل‌ها"
                          @click="DownloadAttachment(props.row.id, null)"
                        >
                          <i class="fas fa-download" aria-hidden="true"></i>
                          <span>دانلود فایل‌ها</span>
                        </button>
                        <button
                          class="list-vam-requests-row-btn list-vam-requests-row-btn--status"
                          type="button"
                          title="تغییر وضعیت"
                          @click="Changestate(props.row)"
                          data-toggle="modal"
                          data-target="#Modal-light"
                        >
                          <i class="fas fa-exchange-alt" aria-hidden="true"></i>
                          <span>تغییر وضعیت</span>
                        </button>
                      </div>
                    </template>
                  </vue-bootstrap4-table>
                </div>
              </div>
            </template>
          </net-pa-card>
        </div>
      </div>
    </div>
    <modal-custom>
      <template v-slot:ContentModalLight>
        <div class="list-vam-requests-modal" dir="rtl">
          <div v-if="ShowZamen" class="list-vam-requests-modal__panel">
            <div class="list-vam-requests-modal__header">
              <div class="list-vam-requests-modal__intro">
                <h6 class="list-vam-requests-modal__title">
                  <i class="fas fa-user-friends" aria-hidden="true"></i>
                  اطلاعات ضامن‌ها
                </h6>
                <p
                  v-if="SelectedVamInfo"
                  class="list-vam-requests-modal__subtitle"
                >
                  {{ SelectedVamInfo.fullName }}
                  <span v-if="SelectedVamInfo.codeRahgiri">
                    · کد رهگیری {{ SelectedVamInfo.codeRahgiri }}
                  </span>
                </p>
              </div>
              <button
                type="button"
                class="list-vam-requests-modal__close"
                data-dismiss="modal"
                aria-label="بستن"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="list-vam-requests-modal__body">
              <!-- T1103648 : ta javab nayamade / dar khata , list-e ghabli ya «ثبت نشده» neshan dade nashavad -->
              <p v-if="ZamenLoading" class="list-vam-requests-modal__empty">
                در حال دریافت اطلاعات ضامن‌ها ...
              </p>
              <p v-else-if="ZamenError" class="list-vam-requests-modal__empty">
                {{ ZamenError }}
              </p>
              <div
                v-else-if="visibleZamen.length"
                class="list-vam-requests-zamen-grid"
              >
                <article
                  v-for="(item, key) in visibleZamen"
                  :key="key"
                  class="list-vam-requests-zamen-card"
                  :class="{
                    'list-vam-requests-zamen-card--external':
                      isExternalZamen(item),
                  }"
                >
                  <div class="list-vam-requests-zamen-card__top">
                    <span
                      class="list-vam-requests-zamen-card__avatar"
                      aria-hidden="true"
                    >
                      <i class="fas fa-user"></i>
                    </span>
                    <div class="list-vam-requests-zamen-card__identity">
                      <h6 class="list-vam-requests-zamen-card__name">
                        {{ item.nameFamily }}
                      </h6>
                      <div class="list-vam-requests-zamen-card__tags">
                        <span class="list-vam-requests-zamen-card__tag">{{
                          zamenTypeLabel(item)
                        }}</span>
                        <span
                          v-if="isExternalZamen(item)"
                          class="list-vam-requests-zamen-card__tag list-vam-requests-zamen-card__tag--warn"
                          >عضو نیست</span
                        >
                      </div>
                    </div>
                  </div>
                  <dl class="list-vam-requests-zamen-card__fields">
                    <div class="list-vam-requests-zamen-card__row">
                      <dt>کد ملی</dt>
                      <dd dir="ltr">{{ item.codeMelli || "ثبت نشده" }}</dd>
                    </div>
                    <div class="list-vam-requests-zamen-card__row">
                      <dt>کد پرسنلی</dt>
                      <dd>{{ zamenPersonnelNo(item) }}</dd>
                    </div>
                    <div
                      v-if="item.mobile"
                      class="list-vam-requests-zamen-card__row"
                    >
                      <dt>موبایل</dt>
                      <dd dir="ltr">{{ item.mobile }}</dd>
                    </div>
                    <div class="list-vam-requests-zamen-card__row">
                      <dt>رمز کسر اقساط</dt>
                      <dd>{{ zamenKasrCode(item) || "ثبت نشده" }}</dd>
                    </div>
                  </dl>
                </article>
              </div>
              <p v-else class="list-vam-requests-modal__empty">
                ضامنی برای این درخواست ثبت نشده است
              </p>
            </div>
          </div>

          <div v-else-if="ShowState" class="list-vam-requests-modal__panel">
            <div class="list-vam-requests-modal__header">
              <div class="list-vam-requests-modal__intro">
                <h6 class="list-vam-requests-modal__title">
                  <i class="fas fa-exchange-alt" aria-hidden="true"></i>
                  تغییر وضعیت درخواست
                </h6>
                <p
                  v-if="SelectedVamInfo"
                  class="list-vam-requests-modal__subtitle"
                >
                  {{ SelectedVamInfo.fullName }}
                  <span v-if="SelectedVamInfo.stateVam">
                    · وضعیت فعلی: {{ SelectedVamInfo.stateVam }}
                  </span>
                </p>
              </div>
              <button
                type="button"
                class="list-vam-requests-modal__close"
                data-dismiss="modal"
                aria-label="بستن"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="list-vam-requests-modal__body">
              <label class="list-vam-requests-modal__label" for="vam-new-status"
                >وضعیت جدید</label
              >
              <select
                id="vam-new-status"
                class="form-control list-vam-requests-modal__control"
                v-model="NewGrp312"
                @change="test()"
              >
                <option :value="-1" disabled>انتخاب وضعیت</option>
                <option
                  v-for="(item, key) in Grp312"
                  :key="key"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
              <label
                class="list-vam-requests-modal__label"
                for="vam-status-note"
                >شرح اصلاحات</label
              >
              <textarea
                id="vam-status-note"
                class="form-control list-vam-requests-modal__control list-vam-requests-modal__textarea"
                v-model="Sharh"
                rows="4"
                placeholder="توضیحات مربوط به تغییر وضعیت را بنویسید"
              ></textarea>
            </div>
            <div class="list-vam-requests-modal__footer">
              <button
                type="button"
                class="sv-btn sv-btn--ghost sv-btn--wide"
                data-dismiss="modal"
              >
                انصراف
              </button>
              <button
                type="button"
                class="sv-btn sv-btn--primary sv-btn--wide"
                @click="ChangeGrp312"
              >
                اعمال تغییرات
              </button>
            </div>
          </div>
        </div>
      </template>
    </modal-custom>

    <div class="col-md-2 col-12 mt-3">
      <ExcelExport
        :data="exceltable"
        worksheet-name="Sheet1"
        @success="handleExcelSuccess"
        @error="handleExcelError"
      >
        <button class="btn btn-outline-success d-none">
          <i
            class="fas fa-file-excel btn btn-outline-success Pointer d-none"
            id="DownloadExcel"
          >
            دانلود فایل اکسل
          </i>
        </button>
      </ExcelExport>
    </div>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import VueBootstrap4Table from "vue-bootstrap4-table";
import ModalCustom from "../Tools/ModalCustom.vue";
import loading from "../Tools/NetPa/Loading.vue";
export default {
  components: { Panel, VueBootstrap4Table, NetPaCard, ModalCustom, loading },
  data() {
    return {
      loadingRender: false,
      exceltable: [],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: false,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "نام و نام خانوادگی ",
          name: "fullName",
        },
        {
          label: "کد ملی",
          name: "codeMeli",
        },
        {
          label: "شماره پرسنلی",
          name: "perNo",
        },
        {
          label: "کد رهگیری",
          name: "codeRahgiri",
        },
        {
          label: "نوع تسهیلات ",
          name: "desNoe",
        },
        {
          label: "تاریخ درخواست",
          name: "requestTarix",
        },
        {
          label: "مبلغ درخواست",
          name: "mablagh",
        },
        {
          label: "تعداد اقساط",
          name: "tedadGhest",
        },
        {
          label: "کسر اقساط",
          name: "ramzKasrAghsat",
        },
        {
          label: "وضعیت",
          name: "stateVam",
        },
        {
          label: "شماره حساب (رفاه)",
          name: "hesabNo",
        },
        {
          label: "مدت سپرده",
          name: "sepordeTime",
        },
        {
          label: "عملیات",
          name: "Action",
          sort: false,
          column_classes: "list-vam-requests-action-cell",
        },
      ],
      actions: [
        {
          btn_text: "<i style='font-size:15px' class='fas fa-file-excel '>",
          event_name: "on-download",
          class: "btn  mx-2 btn-outline-success rounded btnEXL ",
          event_payload: {
            msg: "my custom msg",
          },
        },
      ],
      rows: [],
      cardSearch: "",
      cardPage: 1,
      cardPerPage: 10,
      Grp312: [],
      FilterGrp312: -1,
      ListZamen: [],
      ZamenLoading: false,
      ZamenError: "",
      ShowZamen: false,
      ShowState: false,
      NewGrp312: -1,
      Sharh: "",
      SelectedVam: null,
      SelectedVamInfo: null,
    };
  },
  computed: {
    visibleZamen() {
      return (this.ListZamen || []).filter(
        (item) => this.isMemberZamen(item) || this.isExternalZamen(item),
      );
    },
    filteredCardRows() {
      const q = (this.cardSearch || "").trim().toLowerCase();
      if (!q) return this.rows;
      return this.rows.filter((row) => {
        const hay = [
          row.fullName,
          row.codeMeli,
          row.perNo,
          row.codeRahgiri,
          row.desNoe,
          row.requestTarix,
          row.mablagh,
          row.tedadGhest,
          row.ramzKasrAghsat,
          row.stateVam,
          row.hesabNo,
          row.sepordeTime,
        ]
          .filter((v) => v != null && v !== "")
          .join(" ")
          .toLowerCase();
        return hay.includes(q);
      });
    },
    pagedCardRows() {
      const start = (this.cardPage - 1) * this.cardPerPage;
      return this.filteredCardRows.slice(start, start + this.cardPerPage);
    },
    cardPageCount() {
      return Math.max(
        1,
        Math.ceil(this.filteredCardRows.length / this.cardPerPage),
      );
    },
  },
  watch: {
    rows() {
      this.cardPage = 1;
    },
    cardSearch() {
      this.cardPage = 1;
    },
  },
  methods: {
    test() {
      console.log("*******************  ", this.NewGrp312);
    },
    onButtonClick(event) {
      const target = event.target;
      if (
        target &&
        target.closest &&
        target.closest(
          'button, input[type="button"], input[type="submit"], .btn',
        )
      ) {
        this.$ResetTimer();
      }
    },
    Serach() {
      let DataAxios_cmbGrp312 = {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListVamRequests",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("tblComboIdVaziyatGrp312", this.FilterGrp312);
      DataAxios_cmbGrp312.ArryfildValue = formData;
      this.loadingRender = true;
      this.$PostFormData(DataAxios_cmbGrp312)
        .catch((err) => {
          this.loadingRender = false;
          this.b_ShowKhata("جستجـــو ناموفق", err);
          return null;
        })
        .then((res) => {
          if (!res) return;
          this.loadingRender = false;
          // console.log("🤦🏻‍♂️ ~ file: ListVamRequests.vue:231 ~ res:", res)
          if (res.status == "Not Ok") {
            this.$mySweetDefaultTost(
              "جستجـــو ناموفق",
              "اطلاعاتی با فیلتر شما پیدا نشد",
              "warning",
              1000,
            );
            this.rows = [];
            return;
          } else {
            if (res.result.length > 10) {
              this.config.pagination = true;
            } else {
              this.config.pagination = false;
            }
            this.rows = res.result;
            this.exelReport(this.rows);
          }
        });
    },
    GetGrp312() {
      let DataAxios_cmbGrp312 = {
        ArryfildValue: "",
        Method: "Post",
        Action: "SelCombo",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("GrpId", 312);
      DataAxios_cmbGrp312.ArryfildValue = formData;
      this.$PostFormData(DataAxios_cmbGrp312).then((res) => {
        this.Grp312 = res;
        console.log("------------------------------------------");
        console.log(res);
      });
    },
    // T1103648 : modal ba Bootstrap ghabl az javab baz mishavad ; ghablan dar khata (429/401/500) list-e ghabli (aghlab khali)
    // mimand va «ضامنی ثبت نشده» dide mishod . Hala aval khali + «در حال دریافت» , dar khata payam-e vaghei .
    DetailVam(row) {
      this.SelectedVamInfo = row;
      this.ListZamen = [];
      this.ZamenError = "";
      this.ZamenLoading = true;
      this.ShowState = false;
      this.ShowZamen = true;
      const b_VamId = row.id;
      let DataAxios = {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListVamRequests/GetDetailZamen",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("VamId", b_VamId);
      DataAxios.ArryfildValue = formData;
      this.$PostFormData(DataAxios)
        .then((res) => {
          if (!this.SelectedVamInfo || this.SelectedVamInfo.id !== b_VamId)
            return;
          this.ListZamen = Array.isArray(res) ? res : [];
          this.ZamenLoading = false;
        })
        .catch((err) => {
          if (!this.SelectedVamInfo || this.SelectedVamInfo.id !== b_VamId)
            return;
          this.ZamenLoading = false;
          this.ZamenError = this.b_KhataMsg(err);
        });
    },
    b_KhataMsg(err) {
      const status = err && err.response ? err.response.status : 0;
      if (status == 429)
        return "تعداد درخواست‌ها از حد مجاز گذشته است؛ چند دقیقه دیگر دوباره تلاش کنید.";
      if (status == 401)
        return "زمان ورود شما به پایان رسیده است؛ لطفا دوباره وارد شوید.";
      if (status == 403)
        return "دسترسی به این بخش فقط برای مدیر صندوق مجاز است.";
      return "خطا در ارتباط با سرور؛ لطفا دوباره تلاش کنید.";
    },
    b_ShowKhata(title, err) {
      this.$mySweetDefaultTost(title, this.b_KhataMsg(err), "error", 4000);
    },
    isMemberZamen(item) {
      return item && item.azaIdZamen != null;
    },
    isExternalZamen(item) {
      return (
        item &&
        item.azaIdZamen == null &&
        item.mobile != null &&
        item.nameFamily != null
      );
    },
    zamenTypeLabel(item) {
      if (item.tblComboIdNoe10 == 4031) return "ضامن اصلی";
      if (item.tblComboIdNoe10 == 4032) return "ضامن فرعی";
      return "معرف";
    },
    zamenKasrCode(item) {
      if (item.tblComboIdNoe10 == 4031) return item.codeKasreAghsatZamenAsli;
      if (item.tblComboIdNoe10 == 4032) return item.codeKasreAghsatZamenFari;
      return item.codeKasreAghsatMoaref;
    },
    zamenPersonnelNo(item) {
      const value = item.perNoe || item.perNo;
      return value == null || value === "" ? "ثبت نشده" : value;
    },
    DownloadAttachment(id, GRP328) {
      var dataAxios = {
        Method: "POST",
        Action: "Uploader/GetFile",
        Token: this.$session.get("TokenNetPa"), // NetPa HANDOFF P1-4
        ArryfildValue: {
          MasterId: id,
          tableName: "wwwtblNeedVam",
          grp328: GRP328,
        },
      };
      this.$PostData(dataAxios)
        .catch((err) => {
          this.b_ShowKhata("دریافت فایل ناموفق", err);
          return null;
        })
        .then((res) => {
          if (!res) return;
          if (res.status == "error") {
            this.b_ShowKhata("دریافت فایل ناموفق", null);
            return;
          }
          if (res.status == "success") {
            res.data.forEach((img) => {
              var fileLink = document.createElement("a");
              fileLink.download = img.filename;
              fileLink.href =
                "data:application/octet-stream;base64," + img.binary;
              document.body.appendChild(fileLink);
              fileLink.target = "_blank";
              fileLink.click();
            });
          }
          if (res.status == "not success") {
            this.$mySweetDefaultTost(
              "جستجـــو ناموفق",
              "فایل پیوستی برای درخواست انتخابی یافت نشد",
              "warning",
              2000,
            );
          }
        });
    },
    Changestate(row) {
      this.SelectedVam = row.id;
      this.SelectedVamInfo = row;
      this.NewGrp312 = -1;
      this.Sharh = "";
      this.ShowZamen = false;
      this.ShowState = true;
    },
    ChangeGrp312() {
      if (this.NewGrp312 == -1) {
        this.$mySweetDefaultTost(
          "عدم انتخاب وضعیت",
          "لطفا یکی از وضعیت ها را انتخاب نمایید",
          "warning",
          3000,
        );
        return;
      }
      let DataAxios = {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListVamRequests/ChangeCombo312",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("ComboId", this.NewGrp312);
      formData.append("VamId", this.SelectedVam);
      formData.append("Sharh", this.Sharh);
      DataAxios.ArryfildValue = formData;
      console.log("----------------  ", this.NewGrp312);
      this.$PostFormData(DataAxios)
        .catch((err) => {
          this.b_ShowKhata("تغییر وضعیت ناموفق", err);
          return null;
        })
        .then((res) => {
          if (!res) return;
          // console.log('😎 ~ this.$PostFormData ~ res:', res)
          if (res.status == "Ok") {
            this.Serach();
            this.ShowZamen = false;
            this.ShowState = false;
            var genericModalEl = document.getElementById("BtnCloseModal");
            genericModalEl.click();
          }
        });
    },
    Download() {
      document.getElementById("DownloadExcel").click();
    },
    exelReport(rows) {
      // console.log('Reeeeeeeeport', rows);
      this.exceltable = [];
      rows.forEach((element) => {
        var excelrow = {
          "نام و نام خانوادگی": element.fullName,
          "کد ملی": '"' + element.codeMeli.trim() + '"',
          "شماره پرسنلی": element.perNo,
          "کد رهگیری": element.codeRahgiri,
          "نوع تسهیلات": element.desNoe,
          "تاریخ درخواست": element.requestTarix,
          "مبلغ درخواست": element.mablagh,
          "تعداد اقساط": element.tedadGhest,
          "کسر اقساط": element.ramzKasrAghsat,
          وضعیت: element.stateVam,
          "شماره حساب رفاه": element.hesabNo,
          "مدت سپرده": element.sepordeTime,
        };

        this.exceltable.push(excelrow);
      });
      // console.log( this.exceltable);
    },
  },
  created() {
    this.GetGrp312();
  },
};
</script>
<style scoped>
.list-vam-requests-modal {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-border-default: #dbe5eb;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-shadow-md: 0 12px 24px rgba(41, 52, 95, 0.18);
  --bnp-motion-fast: 180ms;
  --bnp-ease-standard: cubic-bezier(0.165, 0.84, 0.44, 1);
  --sv-control-h: 40px;

  display: flex;
  flex-direction: column;
  min-height: 0;
  text-align: right;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

.list-vam-requests-modal__panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.list-vam-requests-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 1rem 1.15rem 0.85rem;
  border-bottom: 1px solid #e8eef2;
}

.list-vam-requests-modal__intro {
  min-width: 0;
  flex: 1 1 auto;
}

.list-vam-requests-modal__title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  color: #29345f;
  font-size: 15px !important;
  font-weight: 800;
  line-height: 1.5;
}

.list-vam-requests-modal__title i {
  display: inline-grid;
  width: 2rem;
  height: 2rem;
  color: #287db4;
  font-size: 13px;
  place-items: center;
  border-radius: 10px;
  background: #edf5fb;
}

.list-vam-requests-modal__subtitle {
  margin: 0.35rem 0 0;
  color: #6b7b8e;
  font-size: 12px !important;
  font-weight: 600;
  line-height: 1.45;
}

.list-vam-requests-modal__close {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin: 0;
  padding: 0;
  color: #29345f;
  font-size: 1.35rem;
  line-height: 1;
  text-shadow: none;
  background: rgba(41, 52, 95, 0.08);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  opacity: 1;
}

.list-vam-requests-modal__close:hover,
.list-vam-requests-modal__close:focus {
  color: #1a2a3a;
  background: rgba(41, 52, 95, 0.14);
  outline: none;
}

.list-vam-requests-modal__body {
  padding: 1rem 1.15rem;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.list-vam-requests-modal__empty {
  margin: 0;
  padding: 1.5rem 0.5rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}

.list-vam-requests-modal__label {
  display: block;
  margin: 0 0 0.4rem;
  color: #29345f;
  font-size: 13px !important;
  font-weight: 700;
}

.list-vam-requests-modal__label
  + .list-vam-requests-modal__control
  + .list-vam-requests-modal__label {
  margin-top: 0.9rem;
}

.list-vam-requests-modal__control {
  width: 100%;
  min-height: 40px;
  padding: 0.45rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
}

.list-vam-requests-modal__control:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

.list-vam-requests-modal__textarea {
  min-height: 6.5rem;
  resize: vertical;
}

.list-vam-requests-modal__footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 0.85rem 1.15rem 1.1rem;
  border-top: 1px solid #e8eef2;
  background: #f8fafc;
}

.list-vam-requests-modal .sv-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: var(--sv-control-h);
  padding: 6px 14px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  border-radius: 12px;
  cursor: pointer;
  transition: color var(--bnp-motion-fast) var(--bnp-ease-standard),
    background var(--bnp-motion-fast) var(--bnp-ease-standard),
    border-color var(--bnp-motion-fast) var(--bnp-ease-standard),
    box-shadow var(--bnp-motion-fast) var(--bnp-ease-standard),
    transform var(--bnp-motion-fast) var(--bnp-ease-standard);
}

.list-vam-requests-modal .sv-btn:focus {
  outline: none;
}

.list-vam-requests-modal .sv-btn:focus-visible {
  box-shadow: var(--bnp-focus-ring);
}

.list-vam-requests-modal .sv-btn--ghost {
  color: var(--bnp-brand-navy);
  border: 1px solid var(--bnp-border-default);
  background: #fff;
}

.list-vam-requests-modal .sv-btn--ghost:not(:disabled):hover {
  color: var(--bnp-brand-purple);
  border-color: rgba(141, 88, 164, 0.28);
  background: rgba(141, 88, 164, 0.05);
}

.list-vam-requests-modal .sv-btn--primary {
  color: #fff;
  border: 0;
  background: linear-gradient(
    110deg,
    var(--bnp-brand-navy),
    var(--bnp-brand-indigo) 58%,
    var(--bnp-brand-purple)
  );
  box-shadow: var(--bnp-shadow-md);
}

.list-vam-requests-modal .sv-btn--primary:not(:disabled):hover {
  color: #fff;
  transform: translateY(-1px);
}

.list-vam-requests-modal .sv-btn--wide {
  min-width: 168px;
  min-height: 44px;
}

.list-vam-requests-zamen-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(15.5rem, 1fr));
  gap: 0.75rem;
}

.list-vam-requests-zamen-card {
  min-width: 0;
  padding: 0.85rem 0.9rem;
  text-align: right;
  background: #f8fafc;
  border: 1px solid #e8eef2;
  border-radius: 14px;
}

.list-vam-requests-zamen-card--external {
  background: #fdf8ef;
  border-color: #eed9b0;
}

.list-vam-requests-zamen-card__top {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin-bottom: 0.75rem;
}

.list-vam-requests-zamen-card__avatar {
  display: inline-grid;
  flex-shrink: 0;
  width: 2.4rem;
  height: 2.4rem;
  color: #287db4;
  font-size: 13px;
  place-items: center;
  border-radius: 12px;
  background: #edf5fb;
}

.list-vam-requests-zamen-card--external .list-vam-requests-zamen-card__avatar {
  color: #9a6b16;
  background: #f8edd6;
}

.list-vam-requests-zamen-card__identity {
  min-width: 0;
}

.list-vam-requests-zamen-card__name {
  margin: 0 0 0.35rem;
  color: #29345f;
  font-size: 13px !important;
  font-weight: 800;
  line-height: 1.4;
}

.list-vam-requests-zamen-card__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.list-vam-requests-zamen-card__tag {
  display: inline-flex;
  align-items: center;
  padding: 0.15rem 0.5rem;
  color: #287db4;
  font-size: 11px;
  font-weight: 700;
  border-radius: 999px;
  background: #edf5fb;
}

.list-vam-requests-zamen-card__tag--warn {
  color: #9a6b16;
  background: #f8edd6;
}

.list-vam-requests-zamen-card__fields {
  margin: 0;
}

.list-vam-requests-zamen-card__row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.4rem 0;
  border-top: 1px solid rgba(219, 229, 235, 0.9);
}

.list-vam-requests-zamen-card__row dt {
  margin: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 600;
}

.list-vam-requests-zamen-card__row dd {
  margin: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  word-break: break-word;
}

@media (max-width: 767px) {
  .list-vam-requests-modal__footer .sv-btn {
    flex: 1 1 auto;
  }
}

@media (prefers-reduced-motion: reduce) {
  .list-vam-requests-modal .sv-btn {
    transition: none;
  }

  .list-vam-requests-modal .sv-btn--primary:not(:disabled):hover {
    transform: none;
  }
}

.list-vam-requests-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 0.75rem;
  width: 100%;
  margin: 0 0 1rem;
  padding: 0 0 1rem;
  border-bottom: 1px solid #e8eef2;
}

.list-vam-requests-field {
  display: flex;
  flex: 0 1 14rem;
  flex-direction: column;
  min-width: 12rem;
  text-align: right;
}

.list-vam-requests-action {
  flex: 0 0 auto;
  min-width: 0;
}

.list-vam-requests-label {
  display: block;
  margin-bottom: 0.35rem;
  min-height: 1.25rem;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px !important;
  font-weight: 700;
  line-height: 1.25rem;
}

.list-vam-requests-label--spacer {
  visibility: hidden;
  user-select: none;
}

.list-vam-requests-field .form-control {
  width: 100%;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.75rem;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.list-vam-requests-field .form-control:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

.list-vam-requests-search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 6.75rem;
  min-height: 40px;
  height: 40px;
  margin: 0;
  padding: 0 1rem;
  border-radius: 12px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
}

>>> .list-vam-requests-action-cell {
  min-width: 15.5rem;
  vertical-align: middle !important;
}

.list-vam-requests-row-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.35rem;
}

.list-vam-requests-cards {
  display: none;
}

.list-vam-requests-cards__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  margin: 0 0 0.85rem;
}

.list-vam-requests-cards__search {
  flex: 1 1 12rem;
  min-width: 0;
  min-height: 40px;
  padding: 0.45rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #dce1e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(42, 63, 84, 0.06);
}

.list-vam-requests-cards__search:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

.list-vam-requests-export-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  color: #1f8a4c;
  border: 1px solid #cfe8d8;
  border-radius: 12px;
  background: #f3faf6;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  cursor: pointer;
}

.list-vam-requests-cards__empty {
  margin: 0.75rem 0 0;
  padding: 1.5rem 1rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border: 1px dashed #dbe5eb;
  border-radius: 14px;
  background: #f8fafc;
}

.list-vam-requests-cards__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.list-vam-requests-card {
  padding: 0.95rem 1rem 0.9rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
}

.list-vam-requests-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.55rem;
}

.list-vam-requests-card__name {
  min-width: 0;
  color: #13243a;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.45;
}

.list-vam-requests-card__badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0.15rem 0.65rem;
  border-radius: 999px;
  color: #287db4;
  background: #edf5fb;
  font-size: 12px;
  font-weight: 800;
}

.list-vam-requests-card__amount {
  margin: 0 0 0.75rem;
  color: #29345f;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.3;
}

.list-vam-requests-card__amount small {
  margin-right: 0.3rem;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.list-vam-requests-card__fields {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin-bottom: 0.75rem;
}

.list-vam-requests-card__field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

.list-vam-requests-card__field span {
  flex-shrink: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.list-vam-requests-card__field strong {
  min-width: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.list-vam-requests-card__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
}

.list-vam-requests-card__actions .list-vam-requests-row-btn {
  flex: 1 1 5.5rem;
}

.list-vam-requests-cards__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 0.85rem;
}

.list-vam-requests-cards__pager-btn {
  min-height: 34px;
  padding: 0.3rem 0.85rem;
  color: #29345f;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.list-vam-requests-cards__pager-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.list-vam-requests-cards__pager-info {
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.list-vam-requests-row-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 34px;
  margin: 0;
  padding: 0.3rem 0.75rem;
  border: 1px solid;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(41, 52, 95, 0.05);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease, box-shadow 0.15s ease;
}

.list-vam-requests-row-btn i {
  font-size: 11px;
}

.list-vam-requests-row-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

.list-vam-requests-row-btn--guarantor {
  color: #287db4;
  border-color: #cfe4f2;
  background: #edf5fb;
}

.list-vam-requests-row-btn--guarantor:hover,
.list-vam-requests-row-btn--guarantor:focus {
  color: #fff;
  border-color: #287db4;
  background: #287db4;
}

.list-vam-requests-row-btn--download {
  color: #2f7a1f;
  border-color: #b7dfb0;
  background: #eef8ec;
}

.list-vam-requests-row-btn--download:hover,
.list-vam-requests-row-btn--download:focus {
  color: #fff;
  border-color: #2f7a1f;
  background: #2f7a1f;
}

.list-vam-requests-row-btn--status {
  color: #8a6414;
  border-color: #eed9b0;
  background: #fff4d6;
}

.list-vam-requests-row-btn--status:hover,
.list-vam-requests-row-btn--status:focus {
  color: #fff;
  border-color: #c48726;
  background: #c48726;
}

@media (max-width: 767px) {
  .list-vam-requests-field,
  .list-vam-requests-action {
    flex: 1 1 100%;
    min-width: 0;
  }

  .list-vam-requests-search-btn {
    width: 100%;
  }

  .list-vam-requests-cards {
    display: block;
  }

  .list-vam-requests-table-view {
    display: none;
  }
}
</style>
<style>
#Modal-light:has(.list-vam-requests-modal) .modal-dialog {
  margin: 1.25rem auto;
  max-width: min(760px, calc(100vw - 2rem));
  width: calc(100% - 2rem);
}

#Modal-light:has(.list-vam-requests-modal) .modal-content {
  background: #fff !important;
  border: none;
  border-radius: 18px;
  box-shadow: 0 8px 32px rgba(42, 63, 84, 0.18);
  overflow: hidden;
  max-height: min(calc(100dvh - 1.5rem), calc(100vh - 1.5rem));
}

#Modal-light:has(.list-vam-requests-modal) .modal-body {
  padding: 0;
  overflow: auto;
  max-height: min(calc(100dvh - 1.5rem), calc(100vh - 1.5rem));
}

@media (max-width: 767px) {
  #Modal-light:has(.list-vam-requests-modal) .modal-dialog {
    margin: 0.75rem auto;
    width: calc(100% - 1.25rem);
    max-width: calc(100% - 1.25rem);
  }

  #Modal-light:has(.list-vam-requests-modal) .modal-content,
  #Modal-light:has(.list-vam-requests-modal) .modal-body {
    max-height: min(calc(100dvh - 1.25rem), calc(100vh - 1.25rem));
    border-radius: 16px;
  }
}
</style>
